// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageModal_wrapper__8YI9j","id":"ImageModal_id__IFqKA","navButton":"ImageModal_navButton__sBfN1"};